import Callout from './components/callout';
import EnhancedSeo from './enhancedSeo';

class StoreLocator {
  constructor() {
    this.map = null;
    this.mapElementID = 'storelocator-map';
    this.autocompleteElementID = 'storelocator-autocomplete';
    this.searchElementID = 'storelocator-load-stores';
    this.locatemeElementID = 'storelocator-locate-me';
    this.listWrapperElementID = 'storelocator-stores-wrapper';
    this.listElementID = 'storelocator-store-list';
    this.selectedElementID = 'store-picker-selected-store';

    this.radius = 30;
    this.autocomplete = null;
    this.bounds = null;
    this.markers = [];
    this.infoWindow = null;
    this.selectedStore = null;

    this.mapEl = document.getElementById(this.mapElementID);

    this.place = {};

    this.initGeolocate = this.initGeolocate.bind(this);

    this.countryToggle();
  }

  init() {
    if (!this.mapEl) return;

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      this.initMap();
      this.initAutocomplete();
      this.initGeolocate();
      this.initEvents();
      this.loadStores();
    };
    // incluso nell'isml con API key configurata
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBPT8F_zyLg7biX7MipV6RRQujx4O5wWZ8&libraries=places';
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  initAutocomplete() {
    const autocompleteInput = document.getElementById(this.autocompleteElementID);
    this.autocomplete = new google.maps.places.Autocomplete(autocompleteInput);

    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    this.autocomplete.bindTo('bounds', this.map);

    this.autocomplete.addListener('place_changed', () => {
      var place = this.autocomplete.getPlace();

      this.place = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
        name: place.name
      };

      if (!place.geometry) {
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }

      if (!!place.address_components && place.address_components.length) {
        let countryStore = '';
        place.address_components.forEach((element) => {
          if (element.types[0].toLowerCase() == 'country') {
            countryStore = element.long_name;
          }
        });
        dataLayer.push({
          event: 'asyncAction',
          gaHitType: 'event',
          event_category: 'find_a_store',
          event_action: countryStore,
          event_label: [place.address_components[0].long_name, this.radius].join('|')
        });
      }

      this.loadStores();
    });
  }

  initMap() {
    const mapOtions = {
      zoom: 4,
      center: {
        lat: this.mapEl.dataset.latitude ? Number(this.mapEl.dataset.latitude) : 0,
        lng: this.mapEl.dataset.longitude ? Number(this.mapEl.dataset.longitude) : 0
      },
      mapTypeControl: false,
      streetViewControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: false,
      zoomControl: true,
      styles: [{
        featureType: 'administrative',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#444444'
        }]
      },
      {
        featureType: 'administrative.country',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        },
        {
          hue: '#ff0000'
        }
        ]
      },
      {
        featureType: 'landscape',
        elementType: 'all',
        stylers: [{
          color: '#f2f2f2'
        }]
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'poi.attraction',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'poi.business',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'poi.government',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'poi.medical',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [{
          saturation: -100
        },
        {
          lightness: 45
        }
        ]
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [{
          visibility: 'simplified'
        }]
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      },
      {
        featureType: 'water',
        elementType: 'all',
        stylers: [{
          color: '#cecece'
        },
        {
          visibility: 'on'
        }
        ]
      }
      ]
    };

    this.map = new google.maps.Map(this.mapEl, mapOtions);
  }

  initGeolocate() {
    $('#' + this.listWrapperElementID).addClass('loading');
    document.getElementById(this.autocompleteElementID).value = '';

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.place = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        this.loadStores(true);
      }, (error) => {
        window.alert(error.message);
      });
    } else {
      this.loadStores();
    }
  }

  selectFirstOnEnter(input, callback) {
    const _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

    function addEventListenerWrapper(type, listener) {
      if (type === 'keydown') {
        const origListener = listener;
        listener = function (event) {
          const suggestionSelected = $('.pac-item-selected').length > 0;
          if (event.which === 13 && !suggestionSelected) {
            const simulatedDownarrow = $.Event('keydown', {
              keyCode: 40,
              which: 40
            });
            origListener.apply(input, [simulatedDownarrow]);

            setTimeout(() => {
              if (typeof callback === 'function') {
                callback();
              }
            }, 500);
          }
          origListener.apply(input, [event]);
        };
      }
      _addEventListener.apply(input, [type, listener]);
    }
    if (input.addEventListener) {
      input.addEventListener = addEventListenerWrapper;
    } else if (input.attachEvent) {
      input.attachEvent = addEventListenerWrapper;
    }
  }

  initEvents() {
    //const searchButton = document.getElementById(this.searchElementID);
    const locateButton = document.getElementById(this.locatemeElementID);
    const input = document.getElementById('storelocator-autocomplete');

    //searchButton.addEventListener('click', this.reverseGeocode.bind(this));
    locateButton.addEventListener('click', this.initGeolocate.bind(this));

    this.selectFirstOnEnter(input, () => {
      searchButton.click();
    });
  }

  loadStores(isInitGeolocate) {
    $('#' + this.listWrapperElementID).addClass('loading');

    // remove markers from the map
    if (this.markers.length) {
      for (var k in this.markers) {
        this.markers[k].setMap(null);
      }
    }
    this.selectedStore = null;
    this.markers = [];

    if (this.markerCluster) this.markerCluster.clearMarkers();
    if (this.infoWindow) this.infoWindow.close();

    if (this.place.latitude === null || this.place.longitude === null) {
      $('#' + this.listWrapperElementID).removeClass('loading');
      this.refreshList();
      return;
    }

    this.bounds = new google.maps.LatLngBounds();

    this.place.country = this.mapEl.dataset.country;
    this.place.region = this.mapEl.dataset.region;
    this.place.province = this.mapEl.dataset.province;

    $.ajax({
      type: 'GET',
      url: this.mapEl.dataset.endpoint,
      data: {
        lat: this.place.latitude,
        long: this.place.longitude,
        radius: this.radius,
        country: this.place.country ? this.place.country : null,
        province: this.place.province ? this.place.province : null,
        region: this.place.region ? this.place.region : null
      },
      success: (response) => {
        let textBoutique = $('.storelocator-zone').data('storelocator-title');
        $('.storelocator-zone').html(`${this.place.name === undefined ? '' : this.place.name}  <span>${response.stores.length}</span> ${textBoutique}`);

        this.markers = response.stores.map((store) => {
          this.bounds.extend(
            new google.maps.LatLng(Number(store.latitude), Number(store.longitude))
          );

          var markerOptions = {
            position: {
              lat: Number(store.latitude),
              lng: Number(store.longitude)
            },
            map: this.map,
            title: store.name,
            storeID: store.ID,
            store: store,
            icon: store.icon
          };

          let marker = new google.maps.Marker(markerOptions);

          marker.addListener('click', (e) => {
            this.markerClicked(marker);
          });

          return marker;
        });

        if (isInitGeolocate && this.markers && this.markers.length) {
          var storeUrl = this.markers[0].store.url.replace(location.protocol + '//' + location.hostname, '');
          var pathnameSplit = storeUrl.split('/');
          pathnameSplit.pop();
          window.history.replaceState('Object', document.title, pathnameSplit.join('/'));
          var storelocatorTitle = $('.storelocator-zone').attr('data-storelocator-title');
          $('.storelocator-zone').html(pathnameSplit[pathnameSplit.length - 1].charAt(0).toUpperCase() + pathnameSplit[pathnameSplit.length - 1].slice(1) + ' <span> ' + response.stores.length + ' </span> ' + storelocatorTitle);

          var locale = pathnameSplit.shift();
          var hrefBreadcrumbs = '';
          pathnameSplit.forEach((path, i) => {
            if (i == 0) {
              hrefBreadcrumbs += '<a href="' + location.protocol + '//' + location.hostname + '">'
                + 'Home / '
                + '</a>';
            } else if (i == 1) {
              hrefBreadcrumbs += '<a href="' + locale + '/' + path + '">'
                + storelocatorTitle.charAt(0).toUpperCase() + storelocatorTitle.slice(1) + ' / '
                + '</a>';
            } else {
              hrefBreadcrumbs += '<a href="' + locale + '/' + pathnameSplit.slice(0, i + 1).join('/') + '">'
                + path.charAt(0).toUpperCase() + path.slice(1) + ((i == pathnameSplit.length - 1) ? '' : ' / ')
                + '</a>';
            }
          });
          $('.breadcrumbs').html(hrefBreadcrumbs);
          $('.country-selector').hide();
        }

        if (this.markers.length) {
          if (this.markers.length > 1) {
            this.markerCluster = new MarkerClusterer(this.map, this.markers, {
              imagePath: this.mapEl.dataset.images + '/m'
            });
          }

          if (this.selectedStore) {
            this.goToMarker(this.selectedStore, 14);
          } else if (this.markers.length > 1) {
            this.map.fitBounds(this.bounds);
          } else {
            this.goToMarker(this.markers[0], 14);
          }
        }

        this.refreshList();
        $('#' + this.listWrapperElementID).removeClass('loading');
      },
      error: (response) => {
        // window.alert('Error while fetching the stores!');
        Callout.error(null, 'Error while fetching the stores!', document.getElementById('store-locator-error-wrapper'));
        $('#' + this.listWrapperElementID).removeClass('loading');
      }
    });
  }

  markerClicked(marker) {
    this.openInfo(marker);
    this.selectStore(marker);
  }

  goToMarker(marker, zoomLvl) {
    this.map.setZoom(zoomLvl);
    this.map.panTo(marker.getPosition());
    this.openInfo(marker);
  }

  refreshList() {
    let storeRows = [];
    if (this.markers.length) {
      this.markers.forEach((marker) => {
        let storeRow = [
          '<li id="store-row-' + marker.store.id + '">',
          '<strong>' + marker.store.name + '</strong>',
          '<p>' + marker.store.address1 + '</p>',
          '<div>',
          '<span class="shop-phone">' + marker.store.phone + '</span>',
          '<a href="' + marker.store.url + '" class="underline">' + this.mapEl.dataset.details + '</a>',
          '</div>',
          '</li>'
        ];

        storeRow = $(storeRow.join(''));
        storeRow.on('click', (e) => {
          if (e.target.nodeName !== 'A') {
            this.goToMarker(marker, 14);
            this.selectStore(marker);
          } else {
            EnhancedSeo.clickStoreDetails(marker, ['#storelocator-store-list', 'a']);
          }
        });

        storeRows.push(storeRow);
      });
    } else {
      storeRows.push('<li class="no-stores">' + this.mapEl.dataset.nostore + '</li>');
      $('.storelocator-zone span').text(0);
    }

    $(`#${this.listElementID}`).empty().append(storeRows);
  }

  openInfo(marker) {
    let infoWindowContent = [
      '<div class="storelocator-marker-content">',
      '<div class="shop-title">' + marker.store.name + '</div>',
      '<div class="shop-address">' + marker.store.address1 + '</div>',
      '<div class="shop-phone">' + marker.store.phone + '</div>',
      '<div class="shop-schedule">' + marker.store.storeHoursInLine + '</div><br />',
      '<a href="' + marker.store.url + '" class="underline">' + this.mapEl.dataset.details + '</a>',
      '</div>'
    ];

    if (this.infoWindow) {
      this.infoWindow.close();
    }

    infoWindowContent = $(infoWindowContent.join(''));
    // infoWindowContent.find('.select-store-btn').on('click', e => {
    //     this.selectStore(marker);
    // });

    this.infoWindow = new google.maps.InfoWindow({
      content: infoWindowContent[0]
    });

    this.infoWindow.open(this.map, marker);
  }

  selectStore(marker) {
    if (this.selectedStore) {
      this.selectedStore.setIcon(`${this.mapEl.dataset.images}/marker.png`);
    }

    this.selectedStore = marker;
    this.selectedStore.setIcon(`${this.mapEl.dataset.images}/marker-selected.png`);

    $(`#${this.listElementID} li`).removeClass('selected');
    $('#store-row-' + marker.store.id).addClass('selected');

    EnhancedSeo.selectedStoreDetail(marker);
  }

  countryToggle() {
    $('.country-selector h4').click((e) => {
      $('.country-selector ul').slideToggle();
    });
  }

  reverseGeocode() {
    const autocompleteInput = document.getElementById(this.autocompleteElementID);

    if (!autocompleteInput.value.length) {
      this.place = {
        latitude: null,
        longitude: null
      };
      this.loadStores();
    } else {
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: autocompleteInput.value }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          const place = results[0];
          this.place = {
            latitude: place.geometry.location.lat,
            longitude: place.geometry.location.lng
          };

          if (!!place.address_components && place.address_components.length) {
            let countryStore = '';
            place.address_components.forEach((element) => {
              if (element.types[0].toLowerCase() == 'country') {
                countryStore = element.long_name;
              }
            });
            dataLayer.push({
              event: 'asyncAction',
              gaHitType: 'event',
              event_category: 'find_a_store',
              event_action: countryStore,
              event_label: [place.address_components[0].long_name, this.radius].join('|')
            });
          }
        } else {
          this.place = {
            latitude: null,
            longitude: null
          };
        }
      });
      this.loadStores();
    }
  }
}

const storeLocator = new StoreLocator();
storeLocator.init();



// WEBPACK FOOTER //
// ./assets/scripts/storelocator.js